import { createFileRoute } from '@tanstack/react-router';
import { ImpressaoPage } from '@/features/impressao/page/ImpressaoPage';

export const Route = createFileRoute('/p/impressao/$filetype')({
    component: Component,
});

function Component() {
    return <ImpressaoPage authenticated={false} />;
}
